import { redirect } from 'next/navigation';
import CheckoutPaymentCallback from 'components/gruenland/organisms/checkout/payment-callback/CheckoutPaymentCallback';
import { TasticProps } from '../../types';

const YggdrasilCheckoutPaymentCallbackTastic = ({ searchParams }: TasticProps) => {
  if (searchParams.redirect_status !== 'succeeded') {
    return redirect('/cart/?error=paymentFailed');
  }
  const cartId = searchParams.cartId;
  if (!cartId) {
    return redirect('/cart/?error=paymentFailed');
  }

  return <CheckoutPaymentCallback cartId={cartId} />;
};

export default YggdrasilCheckoutPaymentCallbackTastic;
